/** 仅后端明确返回实际扣币时记录消费；不以标价推算扣款。 */
export function consumptionParams(data: Record<string, any>, request: Record<string, any>, autoUnlock: boolean) {
  const coins = Number(data.coinNum)
  const freeCoins = Number(data.coinExpirableNum)
  if (!Number.isFinite(coins) || !Number.isFinite(freeCoins) || coins < 0 || freeCoins < 0 || coins + freeCoins <= 0)
    return null
  return {
    book_id: data.contentId ?? request.contentId,
    book_name: data.contentName,
    chapter_id: data.contentChapterId ?? request.contentChapterId,
    chapter_name: data.contentChapterName,
    coins,
    free_coins: freeCoins,
    unlock_method: coins > 0 ? (freeCoins > 0 ? 'both' : 'coins') : 'free_coins',
    is_auto_unlock: autoUnlock ? 1 : 0,
  }
}
